import { getRequestIdFromResponse } from '@office-start/xhr-service';
import { clientRequestIdHeader } from '../constants';
function getServerDebugInfo(response) {
    if (!response || !response.headers) {
        return '';
    }
    var headers = response.headers;
    var backendServer = headers['X-CalculatedBETarget'] || '';
    var frontendServer = headers['X-FEServer'] || '';
    return "BE: ".concat(backendServer, ". FE: ").concat(frontendServer, ".");
}
export function getInstrumentation(fetchRequestIndex, requestId) {
    return function (result, params) {
        params["RequestId" /* InstrumentationParam.RequestId */] =
            getRequestIdFromResponse(result) || '';
        params["DebugInfo" /* InstrumentationParam.DebugInfo */] = getServerDebugInfo(result);
        params["Index" /* InstrumentationParam.Index */] = fetchRequestIndex.toString();
        params["ImpressionId" /* InstrumentationParam.ImpressionId */] =
            (!!result.headers && result.headers[clientRequestIdHeader]) ||
                requestId;
        if (result.ok && result.data) {
            var itemsCount = 0;
            if (result.data.items) {
                itemsCount = result.data.items.length;
                params["ResourceIdDistribution" /* InstrumentationParam.ResourceIdDistribution */] =
                    result.data.items.map(function (d) { return d.resource_id; }).toString();
            }
            params["ActualSize" /* InstrumentationParam.ActualSize */] = itemsCount.toString();
        }
    };
}
//# sourceMappingURL=instrumentResponse.js.map